import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({

    selector: 'syn-loading-check',
    templateUrl: 'loading-check.component.html',
    styleUrls: ['loading-check.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingCheckComponent implements OnChanges {

    @Input() loading = true;
    @Input() size = '24px';

    endLoading = false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.loading) {
            this.endLoading = false;
            setTimeout(() => this.endLoading = true, 1000);
        }
    }
}
